import { render, staticRenderFns } from "./ProtocolloRubricaEditComponent.vue?vue&type=template&id=23c9c513"
import script from "./ProtocolloRubricaEditComponent.vue?vue&type=script&lang=js"
export * from "./ProtocolloRubricaEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports